module.exports = __webpack_public_path__ + "img/jazz_xxl_natural_ba_detail_rsh.741151c9.jpg";